module.exports = __webpack_public_path__ + "media/site_templates/www.localhousepainters.com.au/images/feature_1-7bc2518196d19d58ccf962350a62a690.jpeg";